// 任务状态枚举
export type TaskStatus = 'pending' | 'filming' | 'editing' | 'completed';

// 拍摄方式
export type ShootingMode = 'single' | 'merged';

// 产品分类
export type ProductCategory = 
  | 'padlock'      // 挂锁
  | 'valve_lock'   // 阀门锁
  | 'breaker_lock' // 断路器锁
  | 'lockout_device' // 锁具配件
  | 'other';       // 其他

// 任务接口
export interface Task {
  id: string;
  skuCode: string;           // SKU编号
  productName: string;       // 产品名称
  category: ProductCategory; // 产品分类
  isCore: boolean;           // 是否核心产品
  shootingMode: ShootingMode; // 拍摄方式（单独/合并）
  status: TaskStatus;        // 当前状态
  shootingNotes?: string;    // 拍摄要求
  isPriority?: boolean;      // 是否重点产品
  specialNotes?: string;     // 特殊说明
  mergedSkus?: string[];     // 合并拍摄的SKU列表
  createdAt: string;         // 创建时间
  updatedAt: string;         // 更新时间
}

// 进度统计
export interface ProgressStats {
  total: number;
  pending: number;
  filming: number;
  editing: number;
  completed: number;
  percentage: number;
}

// 状态配置
export const STATUS_CONFIG: Record<TaskStatus, { label: string; color: string; bgClass: string }> = {
  pending: { label: '未开始', color: '#6b7280', bgClass: 'status-pending' },
  filming: { label: '拍摄中', color: '#f59e0b', bgClass: 'status-filming' },
  editing: { label: '剪辑中', color: '#3b82f6', bgClass: 'status-editing' },
  completed: { label: '已完成', color: '#10b981', bgClass: 'status-completed' }
};

// 分类配置
export const CATEGORY_CONFIG: Record<ProductCategory, { label: string }> = {
  padlock: { label: '挂锁' },
  valve_lock: { label: '阀门锁' },
  breaker_lock: { label: '断路器锁' },
  lockout_device: { label: '锁具配件' },
  other: { label: '其他' }
};

// 拍摄方式配置
export const SHOOTING_MODE_CONFIG: Record<ShootingMode, { label: string }> = {
  single: { label: '单独拍摄' },
  merged: { label: '合并拍摄' }
};
